import React from "react";

export function VideoColumn(props){
	let { assetType, encoded } = props.dependentValues
		, videoType = "Uploaded";

	if(!/video/gi.test(assetType)){ return null; }
	if(encoded){
		videoType = "Transcode";
	}

	return (
		<div className={`video-type-col asset-type-${assetType.toLowerCase()}`}>
			<span className={`video-type video-type-${videoType}`}>{videoType}</span>
		</div>
	);
}

const VideoCell = {
	key: "encoded",
	name: "Video Type",
	filter:"Checkbox",
	formatter:VideoColumn,
	getRowMetaData(data){
		return {
			assetType:data.assetType,
			encoded:data.encoded,
		};
	},
	sortable: true,
	resizable:true,
	width:140,
};
export default VideoCell;
